// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1789":"89b2ca9c","7634":"fd89b386","7732":"0365a858","8374":"3aaf6bfa"}[chunkId] + ".v3.chunk.css";
};